import React from 'react';
import { Image } from 'react-bootstrap';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import Button from '../Button';

const MiniProduct = (props) => {
  const { productImage, href, name, description, className } = props;

  const classes = cn('text-start p-3', className);

  return (
    <Button
      as={Link}
      className={classes}
      variant="light"
      to={href}
      style={{
        marginLeft: '-1rem',
        marginRight: '-1rem',
        width: 'calc(100% + 2rem)',
      }}
    >
      <div className="d-flex w-100">
        {productImage && (
          <div className="user-avatar xl-avatar ">
            <Image
              className="img-fluid rounded"
              src={productImage}
              width={60}
              style={{ maxHeight: '60px' }}
            />
          </div>
        )}
        <div className="ms-2 w-100 d-flex flex-column justify-content-center">
          <p className="mb-0">{name}</p>
          {description && <p className="mb-0">{description}</p>}
        </div>
      </div>
    </Button>
  );
};

export default MiniProduct;
